import { landingMotionInView } from "@/utils/landingMotion";
import { motion } from "framer-motion";

export default function Aboutus({ subtitle }: { subtitle: boolean }) {
    return (
        <section className="max-w-[1150px] mx-auto py-10 md:py-20 px-4 xl:px-0">

            {
                subtitle && (
                    <div className="flex justify-center">
                        {/* subtitle The lading prop firm */}
                        <motion.div
                            className="w-fit h-auto p-[1.5px] rounded-[20px] bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] flex justify-center items-center"
                            {...landingMotionInView}
                        >
                            <div className="w-fit px-3 bg-black text-dark rounded-[20px] p-1 flex items-center justify-center">
                                <span
                                    className="bg-clip-text text-[12px] sm:text-[13px] xl:text-base text-transparent font-nexa font-bold uppercase"
                                    style={{
                                        backgroundImage:
                                            "linear-gradient(to left, #D7D536, #20CDE2)",
                                        display: "inline-block",
                                    }}
                                >
                                    {("About us")}
                                </span>
                            </div>
                        </motion.div>
                    </div>
                )}
            <motion.h3
                className="text-[32px] font-nexa max-w-[690px] mx-auto text-center md:text-[56px] leading-tight font-normal pt-2 pb-5"
                {...landingMotionInView}
            >
                Built for Traders<span className="italic [box-decoration-break:clone] px-2 text-gradient font-light ">Who Want Results</span>
            </motion.h3>

            <div className="md:mt-10 mt-5  gap-4 md:gap-5 flex flex-col lg:flex-row font-nexa">
                {/* Big card (col-span-2) */}
                <motion.div
                    {...landingMotionInView}
                    className="w-full xl:w-3/5  overflow-hidden rounded-[24px] border border-white/15 md:bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.02)_100%)] backdrop-blur-[22px]"
                >
                    <div className="relative h-full min-h-[550px] md:min-h-[360px]  px-6 py-5 md:py-10 lg:py-20">
                        <div
                            className="absolute inset-0 opacity-90 hidden md:block"
                            style={{
                                backgroundImage: "url('/image/funnel/card1.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right bottom",
                                backgroundSize: "cover",
                            }}
                            aria-hidden
                        />
                        <div
                            className="absolute inset-0 opacity-90 block h-full w-full md:hidden"
                            style={{
                                backgroundImage: "url('/image/funnel/card1mob.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "bottom center",
                                backgroundSize: "cover",
                            }}
                            aria-hidden
                        />
                        <div className="relative z-10 md:max-w-[380px]">
                            <h3 className="font-nexa text-2xl md:text-[32px] font-bold text-white">
                                Large Simulated <br className="md:block hidden" /> Capital
                            </h3>
                            <p className="mt-3 text-base md:text-lg text-white/60  font-neue">
                                And change the text under it to : Trade simulated accounts from $5K up to $1M, scaling to $2M. Trade by the rules to become eligible for performance-based payouts of up to 80% — no personal capital required, no real funds at risk. Payouts subject to Terms & Conditions.
                            </p>
                        </div>
                    </div>
                </motion.div>

                {/* Small card */}
                <motion.div
                    {...landingMotionInView}
                    className="w-full xl:w-2/5  overflow-hidden rounded-[24px] border border-white/15 bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.02)_100%)] backdrop-blur-[22px]"
                >
                    <div className="relative h-full min-h-[360px] px-6 py-6">
                        <div
                            className="absolute inset-0 opacity-90"
                            style={{
                                backgroundImage: "url('/image/funnel/card2.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: " bottom",
                                backgroundSize: "cover",
                            }}
                            aria-hidden
                        />
                        <div className="relative z-10">
                            <h3 className="font-nexa text-2xl md:text-[32px] font-bold text-white">
                                Rapidly Growing Global Community
                            </h3>
                            <p className="mt-3 text-base md:text-lg text-white/60  font-nexa">
                                Join a fast-growing global community of ambitious traders
                                expanding across markets worldwide.
                            </p>
                        </div>
                    </div>
                </motion.div>


            </div>
            {/* Bottom row cards */}
            <div className="mt-4 md:mt-5  gap-4 md:gap-5 flex flex-col lg:flex-row font-nexa">


                {/* Small card */}
                <motion.div
                    {...landingMotionInView}
                    className="w-full xl:w-2/5  overflow-hidden rounded-[24px] border border-white/15 bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.02)_100%)] backdrop-blur-[22px]"
                >
                    <div className="relative h-full min-h-[360px] px-6 py-6">
                        <div
                            className="absolute inset-0 opacity-90"
                            style={{
                                backgroundImage: "url('/image/funnel/card3.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: " bottom",
                                backgroundSize: "cover",
                            }}
                            aria-hidden
                        />
                        <div className="relative z-10">
                            <h3 className="font-nexa text-2xl md:text-[32px] font-bold text-white">
                                AI-Powered Trading Insights
                            </h3>
                            <p className="mt-3 text-base md:text-lg text-white/60  font-nexa">
                                Trade smarter with AI-powered insights that enhance decision-making, manage risk, and maximize performance.
                            </p>
                        </div>
                    </div>
                </motion.div>
                {/* Big card (col-span-2) */}
                <motion.div
                    {...landingMotionInView}
                    className="w-full xl:w-3/5  overflow-hidden rounded-[24px] border border-white/15 md:bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.02)_100%)] backdrop-blur-[22px]"
                >
                    <div className="relative h-full min-h-[500px] md:min-h-[390px] px-6 py-5 md:py-10 lg:py-20">
                        <div
                            className="absolute inset-0 opacity-90 hidden md:block"
                            style={{
                                backgroundImage: "url('/image/funnel/card4.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right bottom",
                                backgroundSize: "cover",
                            }}
                            aria-hidden
                        />
                        <div
                            className="absolute inset-0 opacity-90 block h-full w-full md:hidden"
                            style={{
                                backgroundImage: "url('/image/funnel/card4mob.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "bottom center",
                                backgroundSize: "cover",
                            }}
                            aria-hidden
                        />
                        <div className="relative z-10 max-w-[420px]">
                            <h3 className="font-nexa text-2xl md:text-[32px] font-bold text-white">
                                Thousands of Active  <br className="md:block hidden" /> Traders
                            </h3>
                            <p className="mt-3 text-base md:text-lg text-white/60 max-w-[350px] font-nexa">
                                Join a rapidly expanding network of traders worldwide who trust the platform to scale their performance. From beginners to professionals, thousands are actively trading, learning, and growing every single day.
                            </p>
                        </div>
                    </div>
                </motion.div>

            </div>

        </section>
    )
}